<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.role === 'merchant' ? userData.merchant.name : userData.name }}
        </p>
        <span class="user-status text-capitalize">{{ userData.role }}</span>
      </div>
      <b-avatar
        size="40"
        :src="userData.photo_url"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.photo_url"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <span
      v-for="(item, index) in menusSelect"
      :key="`list-menu-${index}`"
    >
      <b-dropdown-item
        v-if="!item.to && item.external && !item.isDivider"
        link-class="d-flex align-items-center"
        @click="toLinkEksternal(item.external)"
      >
        <feather-icon
          size="16"
          :icon="item.icon"
          class="mr-50"
        />
        <span>{{ item.title }}</span>
      </b-dropdown-item>

      <b-dropdown-item
        v-else-if="item.to && !item.external && !item.isDivider"
        :to="{ name: item.to}"
        link-class="d-flex align-items-center"
      >
        <feather-icon
          size="16"
          :icon="item.icon"
          class="mr-50"
        />
        <span>{{ item.title }}</span>
      </b-dropdown-item>

      <b-dropdown-divider v-else />
    </span>

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Logout</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      avatarText,
      menus: [
        {
          isDivider: false,
          title: 'Pengaturan',
          icon: 'SettingsIcon',
          to: 'profile',
          role: ['merchant'],
          external: false,
        },
        {
          isDivider: true,
          external: false,
          role: ['merchant'],
          to: false,
        },
        {
          isDivider: false,
          title: 'Bantuan',
          icon: 'HelpCircleIcon',
          to: false,
          role: ['admin', 'merchant'],
          external: 'https://wa.me/6281286867893',
        },
      ],
    }
  },
  computed: {
    menusSelect() {
      return this.menus.filter(el => el.role.includes(this.userData.role))
    },
    userData() {
      return this.$store.state.auth.userData ? this.$store.state.auth.userData : JSON.parse(localStorage.getItem('userData'))
    },
  },
  methods: {
    async logout() {
      await useJwt.logout()
    },
    toLinkEksternal(data) {
      window.open(data, '_blank')
    },
  },
}
</script>
